import './generic_rule.js.coffee'
class Monitoring.Models.ContentRule extends Monitoring.Models.GenericRule
  urlRoot: '/monitoring/content_rules'

class Monitoring.Collections.ContentRulesCollection extends Backbone.Collection
  model: Monitoring.Models.ContentRule
